import { SUPPLIER_ENDPOINTS, requestType } from "../../constants/Variables";
import Api from "../index";

const supplierGetDashboardData = (id) => {
  return Api(
    SUPPLIER_ENDPOINTS.DASHBOARD.GET_DASHBOARD_DATA.replace(":id", id),
    null,
    requestType.GET,
  );
};

const supplierGetMonthlyReport = (id) => {
  return Api(
    SUPPLIER_ENDPOINTS.DASHBOARD.GET_MONTHLY_REPORT.replace(":id", id),
    null,
    requestType.GET,
  );
};

const supplierGetDailyReport = (id, query) => {
  const url = SUPPLIER_ENDPOINTS.DASHBOARD.GET_DAILY_REPORT.replace(":id", id);
  const queryParams = new URLSearchParams();
  if (query.startDate) queryParams.append("startDate", query.startDate);
  if (query.endDate) queryParams.append("endDate", query.endDate);
  
  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

export {
  supplierGetDashboardData,
  supplierGetMonthlyReport,
  supplierGetDailyReport,
};
